<template>
  <div class="notepad-wrapper row no-gutters" style="position: relative;">
    <div class="pz-parent" style="height: 920px;">
      <v-btn style="left:400px; z-index:1" @mouseup="makeGridCols">Columns</v-btn>
      <v-btn style="left:450px; z-index:1" @mouseup="makeGridRows">Rows</v-btn>
      <drag-select
        ref="dragSelect"
        @stopDragSelecting="stopDragSelect"
        @updateSelected="
          setState('selectedCardRefs', $event.selected);
          setState('selectedCardsParent', $event.parentPageId);
        "
        selectionBoxStyling="z-index: 1;"
        :selectableRefs="$refs.cards"
      ></drag-select>
      <div
        ref="canvas"
        class="pz-canvas"
        @mousedown.left.self.prevent.exact="startDragSelect"
        @dblclick.self.stop="showNewCard"
      >
        <template v-for="card in pageNotes">
          <template v-if="tagGroups.includes(card.id)">
            <tag-group :note="card" :key="'tag-' + card.id" :container="{ pageId: pageId }">
            </tag-group>
          </template>
          <item-card v-else ref="cards" :note="card" :key="card.id" :container="{ pageId: pageId }">
          </item-card>
        </template>
        <template v-if="dragOutCard">
          <item-card
            :hoveringContainer="false"
            :hoveringPage="false"
            :note="dragOutCard"
            :container="{ pageId: pageId }"
          >
          </item-card>
        </template>
        <v-card
          v-if="showAddNewCard"
          ref="addNewCard"
          max-width="350"
          :elevation="3"
          class="px-4"
          :style="`left: ${newCard.x}px; top: ${newCard.y}px; position: absolute; z-index: 2};`"
        >
          <new-card-field @input="createCard"></new-card-field>
        </v-card>
        <selection-menu
          v-if="selectedCardRefs.length > 1"
          :style="
            `left:${selectionBound.x - 5}px; width: ${selectionBound.width +
              10}px; top: ${selectionBound.y - 5}px; height: ${selectionBound.height + 10}px;`
          "
          @makeGroup="makeSelectionGroup"
          @makePage="makeSelectionPage"
          @gridSelectedRows="gridSelectedRows"
          @gridSelectedCols="gridSelectedCols"
        ></selection-menu>
      </div>
    </div>
  </div>
</template>

<script>
// import BlankCard from './CardTypes/BlankCard';
import ItemCard from './ItemCard';
import DragSelect from './DragSelect';
import SelectionMenu from './SelectionMenu';
import TagGroup from './TagGroup';
import NewCardField from './NewCardField';
import panzoom from 'panzoom';
import useIdeaBoard from './useIdeaBoard';
import Tween from '@tweenjs/tween.js';

import { pagesModule } from '@/store/database/pagesModule';
import { computed, ref, provide } from '@vue/composition-api';
import { addNote, moveNotes } from '../use/useDocActions';

function stripHTML(textToStrip) {
  var div = document.createElement('div');
  div.innerHTML = textToStrip;
  return div.textContent || div.innerText || '';
}

const ideaBoard = useIdeaBoard();

const { state, setState, makeGrid, makeGridSelected, cardsAreAllNew } = ideaBoard;

export default {
  components: {
    ItemCard,
    DragSelect,
    SelectionMenu,
    TagGroup,
    NewCardField
  },
  // props: ['cards', 'tags', 'contexts'],
  props: ['pageId'],
  setup(props) {
    provide('state', state);
    provide('setState', setState);
    provide('ideaBoard', ideaBoard);

    const pageNotes = computed({
      get() {
        const page = pagesModule.doc(props.pageId).data;
        return Object.values(page.pageNotes)
          .filter(p => !p.toDelete && p.id != undefined)
          .sort((a, b) => (a.order > b.order ? 1 : -1));
        // return notes.map((n, i) => {
        //   const isSection = pagesModule.doc(n.pageId).data.flair.enabled.includes('section');
        //   return { x: 0, y: i * 100 + 30, isSection, ...n };
        // });
      },
      set(v) {
        console.log('set computed', v);
      }
    });
    const tagGroups = computed(() => {
      const groups = [];
      pageNotes.value.forEach(n => {
        if (pagesModule.doc(n.pageId).data.flair.enabled.includes('section')) {
          groups.push(n.id);
        }
      });
      return groups;
    });

    const cardItems = ref([]);
    const tags = ref([]);
    setState('mainPageId', props.pageId);
    // const { pz, selectedCardRefs, draggingCard, hoveringTag } = state;
    return {
      cardItems,
      pageNotes,
      tags,
      ...state,
      setState,
      tagGroups,
      makeGridSelected
    };
  },
  data() {
    return {
      // selectedCardRefs: [],
      // draggingCard: false,
      // hoveringTag: false,
      // spaced: false,
      // showAddNewCard: false,
      // hoverContainer: null,
      // hoverPage: null,
      dropZoneHover: false
    };
  },
  computed: {
    selectionBound() {
      let bound = { x: 0, y: 0, w: 0, h: 0 };
      if (this.selectedCardRefs.length) {
        let lefts = [],
          tops = [],
          rights = [],
          bottoms = [];
        this.selectedCardRefs.forEach(c => {
          lefts.push(c.note.x);
          tops.push(c.note.y);
          rights.push(c.note.x + c.$el.clientWidth);
          bottoms.push(c.note.y + c.$el.clientHeight);
        });
        bound = {
          x: Math.min(...lefts),
          y: Math.min(...tops),
          width: Math.max(...rights) - Math.min(...lefts),
          height: Math.max(...bottoms) - Math.min(...tops)
        };
      }
      return bound;
    }
  },
  mounted() {
    const el = this.$refs.canvas;
    const pz = panzoom(el, {
      smoothScroll: false,
      zoomDoubleClickSpeed: 1,
      filterKey: function(/* e, dx, dy, dz */) {
        // don't let panzoom handle this event:
        return true;
      },
      onDoubleClick: function(e) {
        // `e` - is current double click event.
        return false; // tells the library to not preventDefault, and not stop propagation
      }
    });
    setState('pz', pz);

    //  intiate first make grid thing
    this.$nextTick(() => {
      const cards = this.$refs.cards;
      if (cardsAreAllNew(cards)) {
        console.log('cards are all new,  making a grid');
        makeGrid({ cards: cards, columnFirstMethod: true });
      }
    });

    // this.pageNotes.forEach((n, i) => {
    //   const p = pagesModule.doc(n.pageId).data;
    //   const kids = Object.values(p.pageNotes)
    //     .filter(p => !p.toDelete && p.id != undefined)
    //     .sort((a, b) => (a.order > b.order ? 1 : -1));
    //   const children = kids.map(c => {
    //     const page = pagesModule.doc(c.pageId).data;
    //     if (!page) return [];
    //     return {
    //       id: page.id,
    //       title: stripHTML(page.title),
    //       icon: page.type,
    //       isContainer: false,
    //       showNotePage: false,
    //       tagId: false,
    //       x: 0,
    //       y: 0,
    //       children: [],
    //       childLength: Object.values(page.pageNotes).filter(p => !p.toDelete && p.id != undefined)
    //         .length,
    //       fetched: false
    //     };
    //   });
    //   const isContainer = !!children.length;
    //   this.cardItems.push({
    //     id: p.id,
    //     title: stripHTML(p.title),
    //     icon: p.type,
    //     fetched: true,
    //     tagId: false,
    //     children,
    //     showNotePage: false,
    //     isContainer,
    //     x: 0,
    //     y: i * 100 + 30
    //   });
    // });
    document.addEventListener('keydown', this.handleSpace);
    document.addEventListener('keyup', this.handleSpaceUp);
    document.addEventListener('keydown', this.handleDeleteSelectedCards);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleSpace);
    document.removeEventListener('keyup', this.handleSpaceUp);
    document.removeEventListener('keydown', this.handleDeleteSelectedCards);
  },
  methods: {
    gridSelectedRows() {
      makeGridSelected({ columnFirstMethod: false });
    },
    gridSelectedCols() {
      makeGridSelected({ columnFirstMethod: true });
    },

    makeGridCols() {
      makeGrid({ cards: this.$refs.cards, columnFirstMethod: true });
    },
    makeGridRows() {
      makeGrid({ cards: this.$refs.cards, columnFirstMethod: false });
    },

    moveCards(e) {
      makeGrid({ cards: this.$refs.cards });
    },
    handleSpace(e) {
      if (e.keyCode == 32) {
        setState('spaced', true);
      }
    },
    handleSpaceUp(e) {
      if (e.keyCode == 32) {
        setState('spaced', false);
      }
    },
    showNewCard(e) {
      console.log(e);
      setState('showAddNewCard', true);
      setState('newCard', { x: e.offsetX, y: e.offsetY });
      this.$nextTick(() => {
        this.$refs.addNewCard.focusNewMessage;
      });
    },
    async createCard(text) {
      const id = await addNote({
        pageId: this.pageId,
        pageType: 0,
        html: text,
        x: this.newCard.x,
        y: this.newCard.y
      });
      setState('showAddNewCard', false);
      this.nextTick(() => {
        this.$refs.cards[this.$refs.cards.length].setupEditing();
      });
    },
    startDragSelect(e) {
      if (this.spaced) {
        return;
      }
      this.$refs.dragSelect.clear();
      console.log('drag');
      setState('showAddNewCard', false);
      console.log(state);
      state.pz.value.pause();
      this.$refs.dragSelect.onMouseDown(e);
    },
    stopDragSelect() {
      console.log('stop');
      state.pz.value.resume();
    },
    // handlePageDragEnd(card) {
    //   console.log('handle page drag end');
    //   state.pz.value.resume();
    //   if (this.hoverContainer && this.hoverContainer != card.id) {
    //     console.log(this.hoverContainer, card);
    //     if (this.dropZoneHover) {
    //       const hoverCard = this.cardItems[
    //         this.cardItems.findIndex(c => c.id == this.hoverContainer)
    //       ];
    //       const dropIndex = hoverCard.children.findIndex(a => a.id == this.dropZoneHover);
    //       hoverCard.children.splice(dropIndex, 0, {
    //         ...card
    //       });
    //     } else {
    //       this.cardItems[this.cardItems.findIndex(c => c.id == this.hoverContainer)].children.push({
    //         ...card
    //       });
    //     }

    //     const index = this.cardItems.findIndex(c => c.id == card.id);
    //     console.log('page drag end', index);
    //     this.cardItems.splice(index, 1);
    //   }
    //   if (this.hoveringTag !== false) {
    //     card.tagId = this.hoveringTag;
    //     // this.$emit('addToTag', { tagId: this.hoveringTag, cardId: card.id });
    //   }
    //   setState('draggingCard', false);
    // },
    makeSelectionGroup() {
      const cardIds = this.selectedCardRefs.map(c => c.value.id);
      const text = 'New Section';
      const id =
        'a' +
        Math.random()
          .toString(36)
          .substr(2, 9);
      this.tags.push({ text, id });
      cardIds.forEach(q => {
        const index = this.cardItems.findIndex(quote => quote.id == q);
        this.$set(this.cardItems[index], 'tagId', id);
      });
      setState('selectedCardRefs', []);
    },
    async makeSelectionPage() {
      const selectedNotes = this.selectedCardRefs.map(c => c.note);
      const title = 'New Container';
      //  create a new parent page
      const newPageId = await addNote({
        pageId: this.pageId,
        pageType: 0,
        html: title,
        returnPageId: true,
        x: selectedNotes[0].x,
        y: selectedNotes[0].y
      });

      //  move allt he selected notes to it
      moveNotes({
        noteIds: selectedNotes.map(c => c.id),
        moveToPageId: newPageId,
        moveFromPageId: this.selectedCardsParent,
        moveToPosition: 0
      });

      setState('selectedCardRefs', []);
    },
    handleDeleteSelectedCards(e) {
      if (e.keyCode == 46) {
        console.log('delete');
        // const cardIds = this.selectedCardRefs.map(q => q.value.id);
        // cardIds.forEach(id => {
        //   const index = this.cardItems.findIndex(q => q.id == id);
        //   this.$delete(this.cardItems, index);
        // });
        setState('selectedCardRefs', []);
      }
    },
    updateDragCardPosition(event) {
      const { id } = event; //event
      // let result = [];
      // const movedCard = this.cards.find(q => q.id == 'dragged-' + id );
      // if (this.selectedCardRefs.map(q => q.value.id).includes(id)) {
      //   // the dragged card is a selected card
      //   this.selectedCardRefs.forEach(card => {
      //     const diffX = card.value.x - movedCard.x;
      //     const diffY = card.value.y - movedCard.y;
      //     result.push({ id: card.value.id, x: x + diffX, y: y + diffY });
      //     console.log(diffX, diffY);
      //   });
      // } else {
      //   result = ;
      // }
      this.updateCardPositions({ ...event, id: this.draggingCard.id });
      // this.$emit('updatePosition', [{ ...event, id: 'dragged-' + id }]);
    },
    updateTagPositions(cards) {
      cards.forEach(c => {
        this.updateCardPositions(c);
        // const index = this.cards.findIndex(q => q.id == c.id);
        // this.cards[index].x = c.x;
        // this.cards[index].y = c.y;
      });
    },
    updateCardPositions(event) {
      const { id, x, y } = event; //event
      let result = [];
      const movedCard = this.cardItems.find(q => q.id == id);
      if (this.selectedCardRefs.find(q => q.value.id == id)) {
        // the dragged card is a selected card
        this.selectedCardRefs.forEach(card => {
          const diffX = card.value.x - movedCard.x;
          const diffY = card.value.y - movedCard.y;
          result.push({ id: card.value.id, x: x + diffX, y: y + diffY });
          // result.push({ id: card.value.id, x: x + diffX, y: y + diffY });
          console.log(diffX, diffY);
        });
      } else {
        result = [event];
      }

      result.forEach(r => {
        const index = this.cardItems.findIndex(e => e.id == r.id);
        this.cardItems[index].x = r.x;
        this.cardItems[index].y = r.y;
      });
      // this.cardPositions = { ...this.cardPositions, ...result };
      // this.$emit('updatePosition', result);
    },
    endContextPageDrag(parent) {
      const page = { ...this.draggingCard };
      console.log('end context page drag', page);
      state.pz.value.resume();
      const childIndex = parent.children.findIndex(p => p.id == page.id);
      if (!this.hoverContainer) {
        // we are not over a context, orphan the page
        // this.cardItems.push({
        //   ...page,
        //   x: this.cardItems.find(c => c.id == 'dragged-' + page.id).x,
        //   y: this.cardItems.find(c => c.id == 'dragged-' + page.id).y
        // });
        parent.children.splice(childIndex, 1);
        //  Fetch the children if not fetched
        if (!page.fetched) {
          const p = pagesModule.doc(page.id).data;
          const kids = Object.values(p.pageNotes)
            .filter(p => !p.toDelete && p.id != undefined)
            .sort((a, b) => (a.order > b.order ? 1 : -1));
          const children = kids.map(c => {
            const page = pagesModule.doc(c.pageId).data;
            return {
              id: page.id,
              title: stripHTML(page.title),
              icon: page.type,
              isContainer: false,
              x: 0,
              y: 0,
              children: [],
              childLength: Object.values(page.pageNotes).filter(
                p => !p.toDelete && p.id != undefined
              ).length,
              fetched: false
            };
          });
          const card = this.cardItems.find(c => c.id == page.id);
          card.children = children;
          card.fetched = true;
        }
      } else {
        //  remove the drag card

        if (this.hoverContainer !== parent.id || this.dropZoneHover) {
          const targetIndex = this.cardItems.findIndex(c => c.id == this.hoverContainer);
          parent.children.splice(childIndex, 1);
          if (this.dropZoneHover) {
            const hoverCard = this.cardItems[targetIndex];
            const dropIndex = hoverCard.children.findIndex(a => a.id == this.dropZoneHover);
            hoverCard.children.splice(dropIndex, 0, page);
          } else {
            this.cardItems[targetIndex].children.push(page);
          }
        }
        this.$delete(
          this.cardItems,
          this.cardItems.findIndex(c => c.id == page.id)
        );
      }

      if (this.hoverTag) {
        const card = this.cardItems.find(c => c.id == page.id);
        card.tagId = this.hoveringTag;
        // this.$emit('addToTag', { tagId: this.hoveringTag, cardId: page.id });
      }

      setState('draggingCard', false);
      console.log(this.cardItems);
    }
  }
};
</script>

<style>
.pz-parent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background: #eee;
  touch-action: none;
  overflow: hidden;
}
.pz-canvas {
  position: absolute;
  width: 5000px;
  height: 3000px !important;
  background-repeat: repeat;
  background-color: white;
  backface-visibility: inherit !important;
  background-image: -webkit-linear-gradient(
      0deg,
      transparent 0.05em,
      rgba(0, 0, 0, 0.0470588) 0.05em,
      rgba(0, 0, 0, 0.0470588) 0.125em,
      transparent 0.125em
    ),
    -webkit-linear-gradient(top, rgba(0, 0, 0, 0.0470588) 0.0625em, transparent 0.0625em);
  background-size: 0.75em 0.75em;
  background-position: 0px -0.5em;
}
</style>
